import layoutHeaderAside from '@/layout/header-aside'
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)
// 用户路由
export default [
  {
    path: '/publish',
    name: 'Publish',
    meta: {
      title: '发布',
      auth: true
    },
    // redirect: { name: 'PublishArticle' },
    component: layoutHeaderAside,
    children: [
      {
        path: 'article',
        name: 'PublishArticle',
        meta: {
          title: '文章列表',
          auth: true
        },
        component: _import('new-pub/article')
      },
      {
        path: 'datalist',
        name: 'PublishDataList',
        meta: {
          title: '数据列表',
          auth: true
        },
        component: _import('new-pub/data-list')
      },
      {
        path: 'onlineSignup',
        name: 'onlineSignup',
        meta: {
          title: '在线报名',
          auth: true
        },
        component: _import('new-pub/data-list')
      },
      {
        path: 'videoList',
        name: 'VideoList',
        meta: {
          title: '视频列表',
          auth: true
        },
        component: _import('publish/video-list')
      },
      // {
      //   path: 'articleAdd',
      //   name: 'PublishArticleAdd',
      //   meta: {
      //     title: '新建文章',
      //     auth: true
      //   },
      //   component: _import('publish/article-info')
      // },
      {
        path: 'articleAdd',
        name: 'PublishArticleAdd',
        meta: {
          title: '新建文章',
          auth: true
        },
        component: _import('new-pub/article-data')
      },
      // {
      //   path: 'articleEdit',
      //   name: 'PublishArticleEdit',
      //   meta: {
      //     title: '编辑文章',
      //     auth: true
      //   },
      //   component: _import('publish/article-info')
      // },
      {
        path: 'articleEdit',
        name: 'PublishArticleEdit',
        meta: {
          title: '编辑文章',
          auth: true
        },
        component: _import('new-pub/article-data')
      },
      {
        path: 'datasend',
        name: 'PublishDatasend',
        meta: {
          title: '数据发布',
          auth: true
        },
        component: _import('new-pub/data-send')
      },
      {
        path: 'datasendnew',
        name: 'PublishDatasendNew',
        meta: {
          title: '数据发布',
          auth: true
        },
        component: _import('new-pub/data-send-new')
      },
      {
        path: 'album',
        name: 'PublishAlbum',
        meta: {
          title: '相册管理',
          auth: true
        },
        component: _import('publish/album')
      },
      {
        path: 'albumUploadImg',
        name: 'AlbumUploadImg',
        meta: {
          title: '上传图片',
          auth: true
        },
        component: _import('publish/album-upload-img')
      },
      {
        path: 'albumDetails',
        name: 'AlbumDetails',
        meta: {
          title: '相册详情',
          auth: true
        },
        component: _import('publish/album-details')
      },
      {
        path: 'video',
        name: 'PublishVideo',
        meta: {
          title: '维护视频',
          auth: true
        },
        component: _import('publish/video')
      },
      {
        path: 'live',
        name: 'liveroom',
        meta: {
          title: '直播间管理',
          auth: true
        },
        component: _import('publish/live')
      },
      {
        path: 'feedback',
        name: 'OperateFeedback',
        meta: {
          title: '意见反馈',
          auth: true
        },
        component: _import('operate/feedback')
      },
      {
        path: 'intention',
        name: 'PigeonIntention',
        meta: {
          title: '交鸽意向',
          auth: true
        },
        component: _import('pigeon/intention')
      }
    ]
  }
]
